//@flow

import AboutUsSection from '../../components/Sections/AboutUsSection/AboutUsSection';
import BannerGroupSection from '../../components/Sections/BannerGroup';
import CategoryAisle from '../../components/Sections/CategoryAisle';
import CategoryMenu from '../../components/Sections/CategoryMenu';
import CoverSection from '../../components/Sections/CoverSection/CoverSection';
import FeaturedProducts from '../../components/Sections/FeaturedProducts';
import HeaderBanner from '../../components/Sections/HeaderBanner';
import PopupBanner from '../../components/Sections/PopupBanner';
import RecentProducts from '../../components/Sections/RecentProducts';
import ShippingPromotion from '../../components/Sections/ShippingPromotion';

import type {HomeLayoutSectionType} from '../../../../entities';
import Promotion from '../../components/Sections/Promotions';
import BlogSection from '../../components/Sections/BlogSection';
import OrderReviews from '../../components/Sections/OrderReviews';
import FaqSection from '../../components/Sections/FaqSection';
import Locations from '../../components/Sections/Locations';
import InformationBlock from '../../components/Sections/InformationBlock';

export const HOME_PAGE_SECTION_NAMES = {
  PRODUCT_CATEGORY: 'PRODUCT_CATEGORY',
  FEATURED_PRODUCTS: 'FEATURED_PRODUCTS',
  STORE_BANNER: 'STORE_BANNER',
  STORE_PROFILE: 'STORE_PROFILE',
  RECENT_PRODUCTS: 'RECENT_PRODUCTS',
  PRODUCT_CATEGORY_AISLE: 'PRODUCT_CATEGORY_AISLE',
  STORE_PROMOTIONS: 'STORE_PROMOTIONS',
  SHIPPING_PROMOTION: 'SHIPPING_PROMOTION',
  BLOG: 'BLOG',
  ORDER_REVIEWS: 'ORDER_REVIEWS',
  FAQ: 'FAQ',
  STORE_LOCATION: 'STORE_LOCATION',
  STORE_INFORMATION_BLOCK: 'STORE_INFORMATION_BLOCK',
};

export const STATIC_HOME_PAGE_SECTION_NAMES = {
  HEADER_MESSAGE: 'HEADER_MESSAGE',
  BANNER_POPUP: 'BANNER_POPUP',
  COVER: 'COVER',
  MAIN_BANNER: 'MAIN_BANNER',
};

export type HomePageSection = {
  id: string,
  label: string,
  name: HomeLayoutSectionType,
  Component: React$ComponentType<any>,
  hide?: boolean,
  static?: boolean,
  canDelete?: boolean,
  storeBusinessModels: string[],
};

export type HomePageAddableSection = {
  // id: string,
  title: string | React$Node,
  name: HomeLayoutSectionType,
  onAdd: () => void,
  disabled?: boolean,
  onAdd?: () => void,
};

export const DYNAMIC_HOME_PAGE_SECTIONS: {
  [HomeLayoutSectionType]: HomePageSection,
} = {
  STORE_BANNER: {
    label: 'Banners',
    name: HOME_PAGE_SECTION_NAMES.STORE_BANNER,
    Component: BannerGroupSection,
    id: HOME_PAGE_SECTION_NAMES.STORE_BANNER,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  FEATURED_PRODUCTS: {
    label: 'Elementos destacados',
    name: HOME_PAGE_SECTION_NAMES.FEATURED_PRODUCTS,
    Component: FeaturedProducts,
    id: HOME_PAGE_SECTION_NAMES.FEATURED_PRODUCTS,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  RECENT_PRODUCTS: {
    label: 'Sección novedades',
    name: HOME_PAGE_SECTION_NAMES.RECENT_PRODUCTS,
    Component: RecentProducts,
    id: HOME_PAGE_SECTION_NAMES.RECENT_PRODUCTS,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  PRODUCT_CATEGORY: {
    label: 'Menú de categorías',
    name: HOME_PAGE_SECTION_NAMES.PRODUCT_CATEGORY,
    Component: CategoryMenu,
    id: HOME_PAGE_SECTION_NAMES.PRODUCT_CATEGORY,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  PRODUCT_CATEGORY_AISLE: {
    label: 'Categorías',
    name: HOME_PAGE_SECTION_NAMES.PRODUCT_CATEGORY_AISLE,
    Component: CategoryAisle,
    id: HOME_PAGE_SECTION_NAMES.PRODUCT_CATEGORY_AISLE,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  STORE_PROFILE: {
    label: 'Conócenos',
    name: HOME_PAGE_SECTION_NAMES.STORE_PROFILE,
    Component: AboutUsSection,
    id: HOME_PAGE_SECTION_NAMES.STORE_PROFILE,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  STORE_PROMOTIONS: {
    label: 'Promociones',
    name: HOME_PAGE_SECTION_NAMES.STORE_PROMOTIONS,
    Component: Promotion,
    id: HOME_PAGE_SECTION_NAMES.STORE_PROMOTIONS,
    storeBusinessModels: ['PRODUCT'],
  },
  SHIPPING_PROMOTION: {
    label: 'Promoción de envío',
    name: HOME_PAGE_SECTION_NAMES.SHIPPING_PROMOTION,
    Component: ShippingPromotion,
    id: HOME_PAGE_SECTION_NAMES.SHIPPING_PROMOTION,
    storeBusinessModels: ['PRODUCT'],
  },
  BLOG: {
    label: 'Blog',
    name: HOME_PAGE_SECTION_NAMES.BLOG,
    Component: BlogSection,
    id: HOME_PAGE_SECTION_NAMES.BLOG,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  ORDER_REVIEWS: {
    label: 'Reseñas',
    name: HOME_PAGE_SECTION_NAMES.ORDER_REVIEWS,
    Component: OrderReviews,
    id: HOME_PAGE_SECTION_NAMES.ORDER_REVIEWS,
    storeBusinessModels: ['PRODUCT'],
  },
  FAQ: {
    label: 'Preguntas frecuentes',
    name: HOME_PAGE_SECTION_NAMES.FAQ,
    Component: FaqSection,
    id: HOME_PAGE_SECTION_NAMES.FAQ,
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  STORE_LOCATION: {
    label: 'Ubicaciones',
    name: HOME_PAGE_SECTION_NAMES.STORE_LOCATION,
    Component: Locations,
    id: HOME_PAGE_SECTION_NAMES.STORE_LOCATION,
    storeBusinessModels: ['SERVICE'],
  },
  STORE_INFORMATION_BLOCK: {
    label: 'Informacional',
    name: HOME_PAGE_SECTION_NAMES.STORE_INFORMATION_BLOCK,
    Component: InformationBlock,
    id: HOME_PAGE_SECTION_NAMES.STORE_INFORMATION_BLOCK,
    storeBusinessModels: ['SERVICE', 'PRODUCT'],
  },
};

// $FlowFixMe
export const DYNAMIC_HOME_PAGE_SECTIONS_LIST: HomePageSection[] = Object.values(
  DYNAMIC_HOME_PAGE_SECTIONS
);

export const DYNAMIC_HOME_PAGE_SECTIONS_NAME_LIST: string[] = Object.keys(
  DYNAMIC_HOME_PAGE_SECTIONS
).map(sectionName => {
  return DYNAMIC_HOME_PAGE_SECTIONS[sectionName].name;
});

export const STATIC_HOME_PAGE_SECTIONS = {
  HEADER_MESSAGE: {
    label: 'Mensaje de bienvenida',
    name: STATIC_HOME_PAGE_SECTION_NAMES.HEADER_MESSAGE,
    Component: HeaderBanner,
    id: 'header-banner',
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  BANNER_POPUP: {
    label: 'Aviso Emergente',
    name: STATIC_HOME_PAGE_SECTION_NAMES.BANNER_POPUP,
    Component: PopupBanner,
    id: 'popup-banner',
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  COVER: {
    label: 'Foto de Portada',
    name: STATIC_HOME_PAGE_SECTION_NAMES.COVER,
    Component: CoverSection,
    id: 'cover',
    static: true,
    storeBusinessModels: ['PRODUCT'],
  },
};

// $FlowFixMe
export const STATIC_HOME_PAGE_SECTIONS_LIST: HomePageSection[] = Object.values(
  STATIC_HOME_PAGE_SECTIONS
);

export const NEW_BANNER_GROUP_ID = 'new-banner-group';
